"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.insightReferences = void 0;
// (C) 2021-2023 GoodData Corporation
var sdk_model_1 = require("@gooddata/sdk-model");
var sdk_backend_spi_1 = require("@gooddata/sdk-backend-spi");
function insightReferences(layout) {
    var insightRefsFromWidgets = [];
    if (layout) {
        sdk_backend_spi_1.walkLayout(layout, {
            widgetCallback: function (widget) {
                if (sdk_model_1.isInsightWidget(widget)) {
                    insightRefsFromWidgets.push(widget.insight);
                    widget.drills.forEach(function (drill) {
                        if (sdk_model_1.isDrillToInsight(drill)) {
                            insightRefsFromWidgets.push(drill.target);
                        }
                    });
                }
            },
        });
    }
    return insightRefsFromWidgets;
}
exports.insightReferences = insightReferences;
//# sourceMappingURL=insightReferences.js.map